import { forwardRef, Inject, Pipe, PipeTransform } from '@angular/core';
import { DigitalServiceService } from '../../service/digital-service.service';

@Pipe({ name: 'addOnLabel' })
export class AddOnLabelPipe implements PipeTransform {

    constructor(@Inject(forwardRef(() => DigitalServiceService)) private digitalServiceService: DigitalServiceService) { }

    transform(addOnNames: string | string[], partner?: boolean): any {
        if (!addOnNames) {
            return '';
        }
        return this.digitalServiceService.getAddOnLabels(addOnNames, partner);
    }
}